
<template>
    <div 
        v-if="settings.newsletter_form_enabled" 
        class="newsletter-form padding-4 rich-text"
        :class="{'align-left': alignLeft, 'full-width': fullWidth}"
    >
        <div v-if="submitted" class="rich-text" v-html="successText" />
        <template v-else>
            <div class="header-text">
                <div class="rich-text" v-html="header" />
                <div class="rich-text margin-bottom-4" v-html="text" />
            </div>

            <div
                v-if="emailError"
                class="error"
            >
                <p>{{ settings.newsletter_form_email_error_message }}</p>
            </div>
            <div class="form">
                <input v-model="email" type="email" :placeholder="settings.newsletter_form_email_placeholder">

                <button
                    class="btn btn-sm btn-green"
                    @click="submit"
                >
                    {{ buttonText }}
                </button>
            </div>
            <div class="disclaimer" v-html="terms" />
        </template>
    </div>
</template>
<script>
export default {
    props: {
        sliceData: {
            type: Object,
            required: false,
            default: () => ({})
        },
        fullWidth: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data() {
        return {
            email: '',
            submitted: false,
            emailError: false
        };
    },
    computed: {
        settings() {
            return this.$store.state.settings;
        },
        header() {
            return this.$validateText(this.sliceData.header) ? 
                this.$prismic.asHtml(this.sliceData.header) : 
                this.$prismic.asHtml(this.settings.newsletter_form_header);
        },
        text() {
            return this.$validateText(this.sliceData.text) ? 
                this.$prismic.asHtml(this.sliceData.text) : 
                `<p>${this.settings.newsletter_form_p}</p>`;
        },
        buttonText() {
            return this.$validateText(this.sliceData.button_text) ? 
                this.sliceData.button_text : 
                this.settings.newsletter_form_button_text;
        },
        terms() {
            return this.$validateText(this.sliceData.terms) ? 
                this.$prismic.asHtml(this.sliceData.terms) : 
                this.$prismic.asHtml(this.settings.newsletter_form_disclaimer);
        },
        successText() {
            return this.$validateText(this.sliceData.success_text) ? 
                this.$prismic.asHtml(this.sliceData.success_text) : 
                `<h5>${this.settings.newsletter_form_success_message}</h5>`;
        },
        alignLeft() {
            return this.sliceData.align_content === 'left';
        }
    },
    methods: {
        submit() {
            const validEmailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
            if (! this.email.match(validEmailRegex)) {
                this.emailError = true;
                return;
            }

            this.emailError = false;

            this.$axios
                .post('https://api.broker.compary.com/users', {
                    email: this.email,
                    guide_id: this.$store.state.settings.broker_source_id,
                    tracking: this.$tracking.getTrackingObject(),
                    redirect_url: null
                })
                .then(() => {
                    this.submitted = true;
                });
        }
    }
}
</script>

<style lang="scss" scoped>
    .newsletter-form {
        text-align: center;
        width: 100%; 
        max-width: 600px;
        margin: 0 auto;
        @include spacing(padding, 8);

        &.align-left {
            text-align: left;
        }
        &.full-width {
            max-width: unset;
        }

        .header-text {
            @include spacing(margin, 3, bottom);
        }
    }

    .error {
        width: 100%;
        @include spacing(margin, 4, bottom);
        background: $lightgray;
    }

    .form {
        display: grid;
        grid-template-columns: repeat(1, 1fr);
        gap: 10px;
        @include device(pad) {
            grid-template-columns: repeat(1, 2fr 1fr);

        }

        input {
            font-size: 16px;
        }
        button {
            border-radius: 3px;
        }
    }

    .disclaimer ::v-deep p {
        font-size: 12px;
        line-height: 18px;
        color: $mediumgray;
    }
</style>